// extracted by mini-css-extract-plugin
export default {"badgeForm":"Badge_badgeForm__svDXs","other":"Badge_other__T8jcW","coworker":"Badge_coworker__5cvnn","family":"Badge_family__NJl7i","friend":"Badge_friend__8D5Np"};